import React, { useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from './ModalDialog';

import trashImage from '../../assets/settings/trash.png';
import errorModalHeaderImage from '../../assets/error-modal-header.png';
import { dismissAlert } from '../../actions';
import { CONTACT_US_URL } from '../../constants';

import './CustomModal.css';

export const MODAL_ALERT_TYPES = {
  CONFIRM: 'confirm',
  ERROR: 'error',
};

/**
 * @deprecated Use DialogMessage component instead.
 */
const CustomModal = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const alert = useSelector(({
    common,
  }) => (common.alert), shallowEqual);

  const isOverlayClose = useMemo(() => alert.overlayClose
    || alert.type === MODAL_ALERT_TYPES.ERROR,
  [alert.overlayClose, alert.type]);

  const onPrimaryAction = () => {
    dispatch(dismissAlert());

    if (alert.primaryAction) {
      alert.primaryAction();
    }
  };

  const onSecondaryAction = () => {
    dispatch(dismissAlert());

    if (alert.secondaryAction) {
      alert.secondaryAction();
    }
  };

  const handleCloseModal = () => {
    dispatch(dismissAlert());
  };

  const handleModalOverlayClick = () => {
    if (isOverlayClose) {
      handleCloseModal();
    }
  };

  const renderModal = () => {
    switch (alert.type) {
      case MODAL_ALERT_TYPES.ERROR:
        return (
          <button
            className="Modal-overlay"
            id="ErrorModalOverlay"
            onClick={handleModalOverlayClick}
            type="button"
          >
            <Card className="Error-modal-card">
              <button
                className="Error-modal-close-button"
                onClick={handleCloseModal}
                type="submit"
              >
                <span className="Error-modal-close-text">x</span>
              </button>
              <Image
                className="Error-modal-image-title"
                fluid
                src={errorModalHeaderImage}
              />

              <span className="Error-modal-body-text">
                {t('errorModal.title')}
              </span>
              <div>
                <span className="Error-modal-subtext">
                  {t('errorModal.subtitle')}
                </span>
                <a
                  className="Error-modal-subtext Contact-subtext"
                  href={CONTACT_US_URL}
                >
                  {t('errorModal.subtitleContact')}
                </a>
              </div>
            </Card>
          </button>
        );

      case MODAL_ALERT_TYPES.CONFIRM:
      default:
        return (
          <ModalDialog
            cancelable={isOverlayClose}
            hideCloseIcon
            onClose={handleCloseModal}
            show
          >
            <div className="Confirm-modal-card">
              <img
                alt=""
                className="Confirm-modal-image-title"
                src={alert.image || trashImage}
              />

              <p className="Confirm-modal-body-text">{alert.body}</p>

              <div className="Confirm-modal-actions">
                <button
                  className="Confirm-modal-action Custom-light"
                  onClick={onSecondaryAction}
                  type="button"
                >
                  {alert.secondaryText}
                </button>

                <button
                  className="Confirm-modal-action Custom-info-blue"
                  onClick={onPrimaryAction}
                  type="button"
                >
                  {alert.primaryText}
                </button>
              </div>
            </div>
          </ModalDialog>
        );
    }
  };

  if (!alert.visible) {
    return null;
  }

  return renderModal();
};

export default CustomModal;
